import {UpdateForm} from '@ngxs/form-plugin';
import {Injectable, ModuleWithProviders, NgModule} from '@angular/core';
import {getActionTypeFromInstance, NGXS_PLUGINS, NgxsNextPluginFn, NgxsPlugin, setValue} from '@ngxs/store';


@Injectable()
class NgxsFormClearPlugin implements NgxsPlugin {
    handle(state: any, action: any, next: NgxsNextPluginFn) {
        const type = getActionTypeFromInstance(action);
        let nextState = state;
        if (
            type === UpdateForm.type
            && action?.payload?.value === null
            && action?.payload?.errors === null
        ) {
            nextState = setValue(nextState, `${action.payload.path}.validationErrors`, {});
        }
        return next(nextState, action);
    }
}

@NgModule()
export class NgxsFormClearPluginModule {
    static forRoot(): ModuleWithProviders<any> {
        return {
            ngModule: NgxsFormClearPluginModule,
            providers: [
                {
                    provide: NGXS_PLUGINS,
                    useClass: NgxsFormClearPlugin,
                    multi: true
                },
            ]
        };
    }
}
